@if (isLoading || isLoadingParkings) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (!isLoading && !isLoadingParkings) {
  <div class="md:px-3 lg:px-28 pt-8 bg-white h-full px-5">
    @if (!hasSpecialParams) {
      <div class="py-4 flex justify-between padding-2-5rem-vertical">
        <button class="gap-2 flex items-center" (click)="goToBookingSummary()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="size-6 stroke-[#0D6EFD]">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
          <p class="font-medium text-md text-[#0D6EFD] word-break-all">
            {{ "PARKIFLY.CONFIRMATION.BOOKING_SUMMARY" | transloco }}
          </p>
        </button>
        <button class="gap-2 flex items-center" (click)="(goBack())">
          <p class=" font-medium text-md text-[#0D6EFD]"> {{ 'HANDLE_BOOKING.SKIP_ADDITIONAL_SERVICE' | transloco }}
          </p>
          <svg class="rotate-180 size-6 stroke-[#0D6EFD]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
        </button>
      </div>
    }
    <div>
      <div class="text-xl font-semibold my-2">{{'PARKIFLY.CONFIRMATION.HI' | transloco}} {{ " " + booking?.firstName +
        "!" }} {{
      'HANDLE_BOOKING.ADD_ADDITIONAL_SERVICE_TEXT_1' | transloco }}</div>
      <div class="text-lg font-medium mb-12">{{ 'HANDLE_BOOKING.ADD_ADDITIONAL_SERVICE_TEXT_2' | transloco }}</div>
    </div>
    <div class="self-stretch flex-col justify-start items-start gap-6 flex">
      @if (booking?.additionalServices?.length > 0) {
        <div class="self-stretch rounded-xl border border-zinc-200 p-4">
          <div class="flex flex-wrap items-center justify-between mb-4 gap-2">
            <div class="text-lg font-semibold">{{ 'HANDLE_BOOKING.SELECTED_SERVICES' | transloco }}</div>
            <button
              class="text-md px-3 py-2 rounded-md cancel-button font-medium text-[#1B3777] hover:text-[#0D6EFD] hidden sm:block ml-auto"
              type="button" (click)="goToCancelServices()">
              {{ 'PARKIFLY.MANAGE_BOOKING.CANCEL_SERVICES' | transloco }}
            </button>
          </div>
          @if (getSelectedServices().length > 0) {
            @for (service of getSelectedServices(); track service.id) {
              <div class="self-stretch rounded-xl border border-zinc-200 p-4 mb-3">
                <div class="flex items-center gap-3">
                  <mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox>
                  <div class="flex-1">
                    <div class="leading-loose">
                      {{ getServiceName(service.name) | translateAttribute }}
                    </div>
                  </div>
                </div>
              </div>
            }
            <button
              class="text-md px-3 py-2 rounded-md cancel-button font-medium text-[#1B3777] hover:text-[#0D6EFD] block sm:hidden mt-4 w-full h-14"
              type="button" (click)="goToCancelServices()">
              {{ 'PARKIFLY.MANAGE_BOOKING.CANCEL_SERVICES' | transloco }}
            </button>
          } @else {
            <div class="text-sm text-gray-600">No services selected.</div>
          }
        </div>
      }
      <div class="self-stretch rounded-xl border border-zinc-200 p-4">
        <div class="text-lg font-semibold mb-4">{{ 'PARKING_EDIT.ENHANCE_PARKING_EXP_TEST_2' | transloco | titlecase
        }}</div>
        @if (getAvailableServices().length > 0) {
          @for (service of getAvailableServices(); track service.id) {
            <div class="self-stretch rounded-xl border border-zinc-200 p-4 mb-3">
              <div class="flex items-start gap-3">
                <mat-checkbox [checked]="isServiceSelected(service)" [disabled]="isServicePreselected(service)"
                  (change)="onServiceToggle(service, $event)">
                </mat-checkbox>
                <div class="flex-1 min-w-0">
                  <div class="flex flex-col md:flex-row md:justify-between md:items-start min-w-0">
                    <div class="min-w-0">
                      <div class="text-lg font-medium leading-loose">
                        {{ getServiceName(service.name) | translateAttribute }}
                      </div>
                    </div>
                    <div class="text-lg font-medium text-left mt-2 md:mt-0 md:text-right md:w-24">
                      {{ service.totalPrice }} SEK
                    </div>
                  </div>
                  @if ((getServiceName(service.name) == 'Windscreen replace or repair') || (getServiceName(service.name) == 'Byt eller laga vindruta')) {
                    <div
                      class="my-2">
                      <img src="../../../../../assets/img/Carglass-logo.svg" alt="Carglass logo"
                        class="width-100px" />
                    </div>
                  }
                  @if ((getServiceName(service.name) == 'Bilbesiktning' || getServiceName(service.name) == 'Car inspection')) {
                    <div
                      class="my-2">
                      <img src="../../../../../assets/img/Carspect_logo.svg" alt="Carspect logo"
                        class="width-100px" />
                    </div>
                  }
                  @if ((getServiceName(service.name) == 'Bilservice' || getServiceName(service.name) == 'Car service')) {
                    <div
                      class="my-2">
                      <img src="../../../../../assets/img/car_service_logo.png" alt="Car service logo"
                        class="width-100px" />
                    </div>
                  }
                  <!-- Desktop description - always visible -->
                  <div class="text-md text-gray-600 leading-loose mt-1 break-words hidden sm:block">
                    {{ getServiceDescription(service.description) | translateAttribute }}
                  </div>
                  <!-- Mobile description - collapsible -->
                  <div class="block sm:hidden">
                    <button class="text-sm text-[#4B4A4A] underline mt-3 flex items-center gap-1"
                      (click)="toggleDescription(service.id)" type="button">
                      <span>{{ isDescriptionExpanded(service.id) ? ('HANDLE_BOOKING.HIDE' | transloco) :
                      ('HANDLE_BOOKING.SHOW_DETAILS' | transloco) }}</span>
                      <svg class="w-4 h-4 transition-transform duration-200"
                        [class.rotate-180]="isDescriptionExpanded(service.id)" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 9l-7 7-7-7"></path>
                      </svg>
                    </button>
                    @if (isDescriptionExpanded(service.id)) {
                      <div
                        class="text-md text-gray-600 leading-loose mt-2 break-words">
                        {{ getServiceDescription(service.description) | translateAttribute }}
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        } @else {
          <div class="text-2xl text-gray-600 text-center">{{ 'PARKING_EDIT.ADDITIONAL_SERVICES_ARE_NOT_AVAILABLE' |
          transloco }}</div>
        }
      </div>
    </div>
    @if (pendingServices?.length > 0 && amountForSelectedAdditionalServices > 0) {
      <div
        class="Frame805 self-stretch flex-col justify-start items-start gap-4 flex mt-6">
        <div class="rounded-2xl flex-col w-full justify-start items-start flex warning-box-gradient">
          <div class="flex items-center w-full">
            <div class="flex flex-col">
              <h3 class="text-600-e65100">{{ 'PARKIFLY.CONFIRMATION.AMOUNT_TO_PAY' |
                transloco }}
              </h3>
            </div>
            <div class="text-lg font-semibold text-gray-900">{{ " : "}} {{ amountForSelectedAdditionalServices }}
            SEK</div>
          </div>
        </div>
      </div>
    }
    @if (getAvailableServices().length > 0) {
      <div>
        <div class="pt-4 pb-8 md:pt-8 md:flex md:justify-start md:flex-row-reverse gap-2 padding-2-5rem-vertical">
          <button
            class="w-full px-8 py-3 bg-[#1B3777] hover:bg-[#1B3777] rounded-[4px] font-medium text-md leading-6 flex justify-center md:mb-0 md:w-auto mb-4 md:mb-0 text-white"
            (click)="updateBooking()" [disabled]="(amountForSelectedAdditionalServices <= 0) || (isLoading)">
            {{ 'PRICING.ADDITIONAL_SERVICES.ADD_SELECTED_SERVICES' | transloco }}
          </button>
          <button
            class="w-full px-8 py-3 bg-[#dd4e44] hover:bg-[#dd4e44] rounded-[4px] font-medium text-md leading-6 flex justify-center md:mb-0 md:w-auto mb-4 md:mb-0 text-white"
            (click)="goBack()">
            {{ 'HANDLE_BOOKING.SKIP_ADDITIONAL_SERVICE' | transloco }}
          </button>
        </div>
      </div>
    }
  </div>
}